import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import moment from "moment";
import { getPickupTimeSlots } from "../../utils/pickupTimeSlots";
const Modal = ({
  show,
  setShowTime,
  changeBookingTime,
  lanIndex,
  deliveryType
}) => {
  const displayShow = show ? "block" : "none";
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const [date, setDate] = useState("");
  const [timeSlot, setTimeSlot] = useState("");
  const [availableTimeSlot, setAvailableTimeSlot] = useState([]);
  const { startTime, endTime, weekDays, sameDayOrder, tkOrderAfter, company, additionalPickUpTime, hasSlotControl, token, userId, orderTime, noOfAdvanceDays, pickupTimeInterval } = React.useContext(UserContext);
  const [unavailableTimeSlot, setUnavailableTimeSlot] = useState([]);
  const [slotControlLoading, setSlotControlLoading] = useState(false);
  const [weekDayTxt, setWeekDayTxt] = useState([]);
  const hasSlotControlEnabled = hasSlotControl === true || hasSlotControl === "true";

  const timeSlotArr = getPickupTimeSlots(pickupTimeInterval);

  const formatDate = (date) => {
    return {
      data: moment(date).format("YYYY-MM-DD"),
      day: date.getDate(),
      week: date.getDay()
    }
  };
  const getSelectedDateMoment = () => {
    const selectedDate = moment(date, "YYYY-MM-DD", true);
    return selectedDate.isValid() ? selectedDate : null;
  }

  const getTimeMomentValue = (value) => {
    if (value === undefined || value === null || value === "") return null;
    const isTimestamp = typeof value === "number" || (typeof value === "string" && /^\d+$/.test(value));
    if (isTimestamp) {
      const timestamp = parseInt(value);
      const parsedTimestamp = moment(timestamp);
      if (parsedTimestamp.isValid()) return parsedTimestamp;
    }

    const parsed = moment(value);
    if (parsed.isValid()) return parsed;

    return null;
  }

  const setTimeOnDate = (baseDate, value) => {
    const parsed = getTimeMomentValue(value);
    if (!baseDate || !parsed) return null;

    return baseDate.clone()
      .set("hour", parsed.get("hour"))
      .set("minute", parsed.get("minute"))
      .set("second", 0)
      .set("millisecond", 0);
  }

  const getSlotMomentRange = (timeSlot, windowStart, isOvernight) => {
    const selectedDate = getSelectedDateMoment();
    if (!selectedDate) return null;

    let timeS = timeSlot.split(' - ')[0];
    let timeE = timeSlot.split(' - ')[1];
    let slotStart = selectedDate.clone()
      .set("hour", parseInt(timeS.split(":")[0]))
      .set("minute", parseInt(timeS.split(":")[1]))
      .set("second", 0)
      .set("millisecond", 0);
    let slotEnd = selectedDate.clone()
      .set("hour", parseInt(timeE.split(":")[0]))
      .set("minute", parseInt(timeE.split(":")[1]))
      .set("second", 0)
      .set("millisecond", 0);

    if (slotEnd.isBefore(slotStart)) {
      slotEnd = slotEnd.add(1, "day");
    }

    if (isOvernight && slotStart.isBefore(windowStart)) {
      slotStart = slotStart.add(1, "day");
      slotEnd = slotEnd.add(1, "day");
    }

    return { slotStart, slotEnd };
  }

  const getPickUpTimeSlotInfo = (startTime, endTime, timeSlot) => {
    const selectedDate = getSelectedDateMoment();
    if (!selectedDate) return null;

    let st = setTimeOnDate(selectedDate, startTime);
    let et = setTimeOnDate(selectedDate, endTime);
    if (!st || !et) return null;

    const windowStart = st.clone();
    const isOvernight = et.isBefore(st);
    if (isOvernight) {
      et = et.add(1, "day");
    }

    if (date == moment().format("YYYY-MM-DD")) {
      const readyAt = moment()
        .add(tkOrderAfter ? tkOrderAfter : 0, "minute")
        .set("second", 0)
        .set("millisecond", 0);
      if (readyAt.isAfter(st)) {
        st = readyAt;
      }
    }

    const slotRange = getSlotMomentRange(timeSlot, windowStart, isOvernight);
    if (!slotRange) return null;

    if (slotRange.slotEnd.isSameOrAfter(st) &&
      slotRange.slotStart.isSameOrBefore(et) && slotRange.slotEnd.isSameOrBefore(et)
    ) {
      return {
        slotStart: slotRange.slotStart,
        slotEnd: slotRange.slotEnd,
        windowStart: st,
        windowEnd: et
      };
    }

    return null;
  }

  const getWeekDay = (dateString) => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth();

    let days;
    if (company._id == "677ae529d90797dc89c7091a" || company._id == "6805bc98e75fb1ce8570ff56" || company._id == "68c3e1fa1b4ff1ed132de4b4" || company._id == "699d1acc1523f7fcac052961") {
      days = 3;
    } else if (noOfAdvanceDays) {
      days = noOfAdvanceDays;
    } else
      days = new Date(year, month + 1, 0).getDate();

    return Array.from({ length: days }, () => 0).map((val, index) => {
      return formatDate(new Date(moment(dateString).add(index, "day").valueOf()));
    });
  }
  const arrChange = (arr) => {
    //arr format
    //*******
    // data: "YYYY-MM-DD",
    // day: 1~30,
    // week: 0~6, sunday ~ monday
    //********** */
    //to convert to 2d array
    //the nested array always start with sunday
    if (!arr || arr.length == 0) return [];
    if (arr[0].week != 0) { //sunday
      arr = Array(arr[0].week).fill('').concat(arr);
    }
    if (arr[arr.length - 1].week != 6) { //monday
      arr = arr.concat(Array(6 - arr[arr.length - 1].week).fill(''));
    }
    let newArr = [];
    while (arr.length > 0) {
      newArr.push(arr.splice(0, 7));
    }

    return newArr;
  }

  const getTimeSlotAvailability = (timeSlot) => {
    if (!date) return null;
    let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let day = new Date(date).getDay();
    if (weekDays && weekDays.indexOf(tdyTxt[day]) > -1) {
      const slotInfo = getPickUpTimeSlotInfo(startTime, endTime, timeSlot);
      if (slotInfo) return slotInfo;
    }
    const pickUpTimes = Array.isArray(additionalPickUpTime) ? additionalPickUpTime : [];
    for (let pk of pickUpTimes) {
      if (pk.weekDays && pk.weekDays.indexOf(tdyTxt[day]) > -1) {
        const slotInfo = getPickUpTimeSlotInfo(pk.startTime, pk.endTime, timeSlot);
        if (slotInfo) return slotInfo;
      }
    }
    return null;
  }

  const isCurrentTime = (item) => {
    const slotInfo = getTimeSlotAvailability(item);
    if (!slotInfo) return false;

    let now = moment();
    return now.isSameOrAfter(slotInfo.slotStart) && now.isBefore(slotInfo.slotEnd);
  }

  const getAvailableTimeSlot = () => {
    //get Available time slot
    if (!date) return;
    if (hasSlotControlEnabled && slotControlLoading) {
      setAvailableTimeSlot([]);
      return;
    }

    let timeSlotArrNew = timeSlotArr
      .map((item, index) => ({
        item,
        index,
        slotInfo: getTimeSlotAvailability(item)
      }))
      .filter(({ slotInfo }) => (deliveryType == 0 || deliveryType == 1 || deliveryType == 2) && slotInfo)
      .sort((a, b) => {
        const diff = a.slotInfo.slotStart.valueOf() - b.slotInfo.slotStart.valueOf();
        return diff == 0 ? a.index - b.index : diff;
      })
      .map(({ item }) => item);

    setAvailableTimeSlot(timeSlotArrNew);
  }

  const isTimeSlotUnavailable = (item) => unavailableTimeSlot.indexOf(item) >= 0;

  const isTodayAvailable = (day) => {
    let isAvailable = false;
    if (weekDays && weekDays.indexOf(day) > -1) return true;
    if (additionalPickUpTime && Array.isArray(additionalPickUpTime)) {
      additionalPickUpTime.forEach((pk) => {
        if (pk.weekDays && pk.weekDays.indexOf(day) > -1) isAvailable = true;
      })
    }
    return isAvailable;
  }
  useEffect(() => {
    let weekDay = getWeekDay(moment().format("YYYY-MM-DD"));
    setWeekDayTxt(arrChange(weekDay));
    let tdy = moment().get("day");
    let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    tdyTxt = tdyTxt[tdy];
    let isAvailable = isTodayAvailable(tdyTxt);
    if (!isAvailable) return;
    setDate(moment().format("YYYY-MM-DD"));
  }, [additionalPickUpTime, weekDays, startTime, endTime]);

  useEffect(() => {
    if (!show || !hasSlotControlEnabled || !date || !token) {
      setUnavailableTimeSlot([]);
      setSlotControlLoading(false);
      return;
    }

    let isMounted = true;
    setSlotControlLoading(true);
    setUnavailableTimeSlot([]);

    axios.get(`/v2/api/slotControl?userId=${userId}&orderTime=${orderTime}&date=${date}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    }).then(function (response) {
      if (!isMounted) return;
      setUnavailableTimeSlot(response.data.unavailableTimeSlot ? response.data.unavailableTimeSlot : []);
      setSlotControlLoading(false);
    }).catch(function (error) {
   
      if (!isMounted) return;
      setUnavailableTimeSlot([]);
      setSlotControlLoading(false);
    });

    return () => { isMounted = false; };
  }, [show, hasSlotControl, date, token, userId, orderTime]);

  useEffect(() => {
    getAvailableTimeSlot();
  }, [date, unavailableTimeSlot, slotControlLoading, deliveryType, startTime, endTime, weekDays, additionalPickUpTime, tkOrderAfter, pickupTimeInterval]);

  const modalContent = () => {

    return (
      <React.Fragment key={0}>
        <ModelWrapperLeft>
          <ModalBox>
            {!sameDayOrder ?
              weekDayTxt && weekDayTxt.map((i, idx1) => (
                <ModelWeeks key={idx1}>
                  {
                    i.filter(j => j !== "").map((j, idx2) => (
                      <ModelWeekWrap key={idx1 + '-' + idx2}
                        isSelect={date == j.data}
                        color={'black'}
                        onClick={() => {
                          if (j == '') return;
                          if (!isTodayAvailable(moment(j.data, "YYYY-MM-DD", true).format('dddd'))) return;
                          setDate(j.data);
                          setTimeSlot('')
                        }}
                      >
                        <div>
                          <ModelWeekDayTxt themeContext={themeContext}
                            opacity={!isTodayAvailable(moment(j.data, "YYYY-MM-DD", true).format('dddd')) ? 0.3 : 1}
                            color={'black'}
                            backgroundColor={date == j.data ? '#fff' : ''}
                          >{moment(j.data, "YYYY-MM-DD", true).format("DD MMM")}</ModelWeekDayTxt>
                          <ModelWeekTxt
                            opacity={!isTodayAvailable(moment(j.data, "YYYY-MM-DD", true).format('dddd')) ? 0.5 : 1}
                            color={'black'}
                          >
                            {moment(j.data, "YYYY-MM-DD", true).format("ddd")}
                          </ModelWeekTxt>
                        </div>
                      </ModelWeekWrap>
                    ))
                  }
                </ModelWeeks>
              ))
              :
              <ModelWeeks >
                <ModelWeekWrap
                  isSelect={date == moment().format("YYYY-MM-DD")}
                  color={'black'}
                  onClick={() => {
                    if (!isTodayAvailable(moment().format('dddd'))) return;
                    setDate(moment().format("YYYY-MM-DD"));
                    setTimeSlot('')
                  }}
                >
                  <div>
                    <ModelWeekDayTxt themeContext={themeContext}
                      opacity={!isTodayAvailable(moment().format('dddd')) ? 0.3 : 1}
                      color={'black'}
                      backgroundColor={date == moment().format("YYYY-MM-DD") ? '#fff' : ''}
                    >{moment().format("DD MMM")}</ModelWeekDayTxt>
                    <ModelWeekTxt
                      opacity={!isTodayAvailable(moment().format('dddd')) ? 0.5 : 1}
                      color={'black'}
                    >
                      {moment().format("ddd")}
                    </ModelWeekTxt>
                  </div>
                </ModelWeekWrap>
              </ModelWeeks>
            }
          </ModalBox>
        </ModelWrapperLeft>
        <ModelWrapperRight>
          <ModalTimeBox>
            {availableTimeSlot.map((item, index) => {
              const isUnavailable = isTimeSlotUnavailable(item);

              return (
                <ModelDate key={index}
                  themeContext={themeContext}
                  isUnavailable={isUnavailable}
                  aria-disabled={isUnavailable}
                  color={isUnavailable ? '#8a8a8a' : timeSlot == item ? '#Cf000d' : 'black'}
                  onClick={() => {
                    if (date == '') return;
                    if (isUnavailable) return;
                    const slotInfo = getTimeSlotAvailability(item);
                    if (!slotInfo) return;
                    setTimeSlot(item);
                    setShowTime(false);
                    changeBookingTime(slotInfo.slotStart.format("YYYY-MM-DD") + ' ' + item);
                  }}>{isCurrentTime(item) ? "Now" : item}</ModelDate>
              );
            })}
            {!slotControlLoading && date && availableTimeSlot.length === 0 &&
              <EmptyState>No time slots are available for this date.</EmptyState>
            }
            {slotControlLoading && <EmptyState>Checking available times…</EmptyState>}
          </ModalTimeBox>
        </ModelWrapperRight>
      </React.Fragment>
    );
  };

  return (
    <ModalContainer display={displayShow}>
      <ModalMain themeContext={themeContext}>
        <ModalTitle themeContext={themeContext}>
          <TitleGroup>
            <TitleEyebrow themeContext={themeContext}>{languageContext[lanIndex].pleaseSelect}</TitleEyebrow>
            <TitleText>{deliveryType == 2 ? languageContext[lanIndex].deliveryTime : languageContext[lanIndex].bookingTime}</TitleText>
          </TitleGroup>
          <DeleteButton
            type="button"
            aria-label={languageContext[lanIndex].close || "Close"}
            themeContext={themeContext}
            onClick={() => {
              setShowTime(false);
            }}
          >
            <IoMdClose size={24} />
          </DeleteButton>
        </ModalTitle>

        <ModalContent themeContext={themeContext}>
          {modalContent()}
        </ModalContent>
      </ModalMain>
    </ModalContainer>
  );
};

export default Modal;

const ModalContainer = styled.div`
  display: ${(props) => props.display};
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100dvh;
  padding: 18px;
  box-sizing: border-box;
  place-items: center;
  background: rgba(15, 23, 42, 0.68);
  backdrop-filter: blur(5px);
  z-index: 30;
`;

const ModalMain = styled.div`
  display: flex;
  width: min(100%, 820px);
  height: min(720px, calc(100dvh - 36px));
  flex-direction: column;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  font-family: ${(props) => props.themeContext.fontFamily};
  background-color: ${(props) => props.themeContext.backgroundColor};
  color: ${(props) => props.themeContext.fontPrimary};
  z-index: 10;
  overflow: hidden;
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
  animation: booking .22s;
  animation-timing-function: ease-out;
  @keyframes booking {
    0%  {
      transform: translateY(24px);
      opacity: 0;
    }
    
    100%  {
      transform: translateY(0px);
      opacity: 1;
    }
    
  }

  @media (max-width: 600px) {
    width: calc(100% + 36px);
    height: calc(100dvh - 10px);
    margin: 10px -18px -18px;
    align-self: end;
    border-radius: 22px 22px 0 0;
  }
`;

const ModalTitle = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  min-height: 76px;
  padding: 16px 18px;
  box-sizing: border-box;
  align-items: center;
  border-bottom: 1px solid rgba(15, 23, 42, 0.1);
  background: ${(props) => props.themeContext.backgroundColor};
`;
const TitleGroup = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  text-align: left;
`;
const TitleEyebrow = styled.span`
  color: ${(props) => props.themeContext.fontPrimary};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.1em;
  opacity: 0.62;
  text-transform: uppercase;
`;
const TitleText = styled.h2`
  margin: 0;
  font-size: 22px;
  line-height: 1.2;
`;
const ModalContent = styled.div`
  background-color: ${(props) => props.themeContext.backgroundColor};
  color: ${(props) => props.themeContext.fontPrimary};
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-align: ${(props) => (props.error ? "left" : "center")};
  align-items: stretch;
  margin-top: 0px;
`;
const ModelWrapperLeft = styled.div`
  width: 230px;
  min-width: 210px;
  height: 100%;
  font-size: 16px;
  background: #f7f8fa;
  border-right: 1px solid rgba(15, 23, 42, 0.08);

  @media (max-width: 600px) {
    width: 118px;
    min-width: 118px;
  }
`;

const ModelWrapperRight = styled.div`
  min-width: 0;
  height: 100%;
  flex: 1 1 auto;
  font-size: 16px;
  overflow-y: auto;
  background: #fff;
 
`;
const ModelDate = styled.div`
  min-height: 46px;
  padding: 0 12px;
  display: grid;
  place-items: center;
  border: 1px solid ${(props) => props.isUnavailable ? '#d7dae0' : (props.color === '#Cf000d' ? props.themeContext.fontPrimary : '#d7dae0')};
  border-radius: 11px;
  color: ${(props) => props.color};
  background-color: ${(props) => props.isUnavailable ? '#f2f3f5' : (props.color === '#Cf000d' ? '#fff7f7' : '#fff')};
  cursor: ${(props) => props.isUnavailable ? 'not-allowed' : 'pointer'};
  opacity: ${(props) => props.isUnavailable ? 0.7 : 1};
  font-size: 13px;
  font-weight: 700;
  transition: transform 140ms ease, border-color 140ms ease, box-shadow 140ms ease;

  &:hover { transform: ${(props) => props.isUnavailable ? 'none' : 'translateY(-1px)'}; box-shadow: ${(props) => props.isUnavailable ? 'none' : '0 5px 14px rgba(15, 23, 42, 0.08)'}; }
`


const DeleteButton = styled.button`
  display: grid;
  place-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(15, 23, 42, 0.11);
  border-radius: 12px;
  color: ${(props) => props.themeContext.fontPrimary};
  background: rgba(15, 23, 42, 0.04);
  cursor: pointer;
`;

const ModelWeeks = styled.div`
`
const ModelWeekWrap = styled.div`
  min-height: 66px;
  display:flex;
  align-items: center;
  justify-content: center;
  margin: 7px 9px;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 12px;
  border:${(props) => props.isSelect ? '1.5px solid ' + props.color : '1px solid transparent'};
  background: ${(props) => props.isSelect ? '#fff' : 'transparent'};
  box-shadow: ${(props) => props.isSelect ? '0 5px 15px rgba(15, 23, 42, 0.08)' : 'none'};
  cursor: pointer;
`;
const ModelWeekTxt = styled.div`
  line-height: 14px;
  font-size:13px;
  opacity: ${(props) => props.opacity};
  color: ${(props) => props.color};
`
const ModelWeekDayTxt = styled.span`
  display: block;
  color: ${(props) => props.color};
  border-radius: 12px;
  opacity: ${(props) => props.opacity};
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 850;
`
const ModalBox = styled.div`
  overflow: auto;
  height: 100%;
`
const ModalTimeBox = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 14px 16px 90px;
  text-align: center;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    padding: 12px 12px 80px;
  }
`
const EmptyState = styled.div`
  grid-column: 1 / -1;
  padding: 40px 16px;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
`;
